<div class="view">
  
  <h2>Notification Contacts</h2>
  <h5>Affected accounts</h5>

  <div class="inline-controls">
      <owc-select-dropdown [label]="'Type'" [formControl]="affAccFC" appearance="fill" size="big" (valueChange)="onAccountsSourceValueChange($event)">
        <owc-list-item value="none">Any</owc-list-item>
        <owc-list-item value="instrument">By instrument</owc-list-item>
        <owc-list-item value="shipments">By shipments</owc-list-item>
      </owc-select-dropdown>

    <div  *ngIf="showAccountsByIntrument && affAccFC.value === 'instrument'">
      <div *ngFor = "let insutrumentNumber of instrumentMaterials; let i = index">
        <owc-input [formControl]="insutrumentNumber.control" [placeholder]="'Instrument material number'" id="instruMatFC-{{i}}" (input)="onMaterialNoValueChange($event, i)" (valueChange)="onMaterialNoValueChange($event, i)" />
      <owc-button *ngIf="instrumentMaterialNumber && i === 0" one-icon-button-flat mat-flat-button matSuffix (click)="addInstrumentField()">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#f00"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
      </owc-button>
      <owc-button *ngIf="instrumentMaterialNumber && i !== 0" one-icon-button-flat mat-flat-button matSuffix (click)="removeInstrumentField(i)">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#EA3323"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
      </owc-button>
      </div>
    </div>

    <div *ngIf="showAccountsByIntrument && affAccFC.value === 'instrument'">
        <owc-select-dropdown [label]="'Status'" [formControl]="instrumentStatusFC" appearance="fill" size="big" (valueChange)="onInstrumentStatusChange($event)">
          <owc-list-item value="none">Any</owc-list-item>
          <owc-list-item value="installed">Installed</owc-list-item>
        </owc-select-dropdown>
    </div>

    <div *ngIf="showAccountsByShipments && affAccFC.value === 'shipments'" class="inline-controls">
      <div *ngFor ="let regMaterialBatchNo of reagentMaterialBatchNumber; let i = index">
        <owc-input [label]="'Reagent material number'" [formControl]="regMaterialBatchNo.reagentMaterialNumber" placeholder="Reagent material number" id="reagentMatFC-{{i}}" (input)="onReagentMaterialNoBatchNoValueChange($event, i)" (valueChange)="onReagentMaterialNoBatchNoValueChange($event, i)" />
        <owc-input [label]="'Batch number'" [formControl]="regMaterialBatchNo.batchNumber" [placeholder]="'Batch number'" id="batchNumFC-{{i}}" (input)="onReagentMaterialNoBatchNoValueChange($event, i)" (valueChange)="onReagentMaterialNoBatchNoValueChange($event, i)" />
      

      <button  *ngIf="regMaterialBatchNo && i === 0"one-icon-button-flat mat-flat-button matSuffix (click)="addReagentBatchField()">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#f00"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
      </button>
      <button *ngIf="regMaterialBatchNo && i !== 0" one-icon-button-flat mat-flat-button matSuffix (click)="removeReagentBatchField(i)">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#EA3323"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
      </button>
      </div>
        <owc-datepicker  [label]="'Date from'" [formControl]="datepickeFromFC" #pickerFrom
        (dateChange)="onDateFromValueChange($event)" (valueChange)="onDateFromValueChange($event)" readonly></owc-datepicker>
       
        <owc-datepicker  [label]="'Date to'" #pickerTo
        [formControl]="datepickeToFC"
        (dateChange)="onDateToValueChange($event)"
        (valueChange)="onDateToValueChange($event)"
        readonly></owc-datepicker>
     
          <owc-select-dropdown [label]="'Partner Role'" [formControl]="shipPartnerRoleFC" multiple appearance="fill" size="big" (visibleChange)="onShipmentPartnerRoleChange()">
            <owc-list-item *ngFor="let role of allRoles" [value]="role" [disabled]="isPartnerRoleDisabled(role)">
              {{ role.toUpperCase() }}
            </owc-list-item>
          </owc-select-dropdown>
      
      
    </div>
  </div>

  <h5>Contacts</h5>

  <div class="inline-controls">
      <owc-select-dropdown [label]="'Type'" [formControl]="contactFC" appearance="fill" size="big" (valueChange)="onContactsSourceValueChange($event)">
        <owc-list-item value="none">None</owc-list-item>
        <owc-list-item value="instrument">By instrument</owc-list-item>
        <owc-list-item value="safetyAndQuality">By contact attributes</owc-list-item>
      </owc-select-dropdown>

    <div *ngIf="((!showAccountsByIntrument && showContactsByInstrument) || affAccFC.value === null ) && contactFC.value === 'instrument'">
      <div *ngFor = "let insutrumentNumber of instrumentMaterials; let i = index">
          <owc-input [label]="'Instrument material number'" [formControl]="insutrumentNumber.control" [placeholder]="'Instrument material number'" id="instruMatFC-{{i}}" (input)="onMaterialNoValueChange($event, i)" (valueChange)="onMaterialNoValueChange($event, i)" />
        <button *ngIf="instrumentMaterialNumber && i === 0" one-icon-button-flat mat-flat-button matSuffix (click)="addInstrumentField()">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#f00"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
        </button>
        <button *ngIf="instrumentMaterialNumber && i !== 0" one-icon-button-flat mat-flat-button matSuffix (click)="removeInstrumentField(i)">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#EA3323"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
        </button>
      </div>
    </div>

    <div *ngIf="showContactsBySafetyAndQuality && contactFC.value === 'safetyAndQuality'" class="inline-controls">
        <owc-select-dropdown [label]="'Attribute type'" [formControl]="attTypFC" appearance="fill" size="big" (valueChange)="onContactAttrTypeValueChange($event)">
          <owc-list-item value="any">Any</owc-list-item>
          <owc-list-item value="qualityNotification">Quality Notification</owc-list-item>
          <owc-list-item value="safetyBoardNotification">Safety Board Notification</owc-list-item>
          <owc-list-item value="supportNotification">Support Notification</owc-list-item>
        </owc-select-dropdown>

        <owc-input [label]="'Attribute value'" [formControl]="attValFC" placeholder="Attribute value" id="attValFC" (input)="onContactAttrValueValueChange($event)" />
     

    </div>

    <div *ngIf="(showContactsByInstrument || showContactsBySafetyAndQuality) && contactFC.value">
        <owc-input [label]="'Contact role'" [formControl]="contRolFC" placeholder="ContactRole" id="contRolFC" (input)="onContactRoleValueChange($event)" />
    </div>

    <div *ngIf="((!showAccountsByIntrument && showContactsByInstrument) || affAccFC.value === null ) && contactFC.value === 'instrument'">
        <owc-select-dropdown [label]="'Status'" [formControl]="instrumentStatusFC" appearance="fill" size="big" (valueChange)="onInstrumentStatusChange($event)">
          <owc-list-item value="none">Any</owc-list-item>
          <owc-list-item value="installed">Installed</owc-list-item>
        </owc-select-dropdown>
    </div>
  </div>

  <div *ngIf="!mappedData || mappedData.length==0" class="inline-controls">
    <owc-button color="primary" (click)="request()" [disabled]="!requestEnabled || isDisabled">
      Request
    </owc-button>
  </div>

  <div *ngIf="mappedData && mappedData.length>0" class="inline-controls">
    <owc-button color="primary" (click)="request()" [disabled]="!requestEnabled">
      Request and merge
    </owc-button>

    <owc-button color="primary" (click)="clear()" [disabled]="!requestEnabled">
      Clear
    </owc-button>
  </div>

  <div *ngIf="records !== 'Error occurred'" style="margin-bottom: 5px;">{{records}}</div>

  <div *ngIf="records === 'Error occurred'" style="color: #D0342C;">{{records}}</div>

  <table>
    <thead>
      <tr>
        <th></th>
        <th>Account ID &nbsp; (ERP)</th>
        <th>CRM Account ID</th>
        <th>Account name</th>
        <th>Contact name</th>
        <th>Contact email</th>
        <th>Contact role</th>
        <th>Attributes</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of mappedData" [ngClass]="{'no-email': (!data.erpAccountNo || !data.accountName || !data.contactEmail)}">
        <td>
          <owc-checkbox 
            *ngIf="data.contactEmail && data.erpAccountNo && data.accountName" 
            [checked]="data.checked"
            (change)="onCheckValueChange($event, data)"
          ></owc-checkbox>
        </td>
        <td>{{data?.erpAccountNo}}</td>
        <td>{{data?.crmAccountNo}}</td>
        <td>{{data?.accountName}}</td>
        <td>{{data?.contactName}}</td>
        <td>{{data?.contactEmail}}</td>
        <td>{{data?.contactRole}}</td>
        <td>
          <span 
            style="cursor: pointer;"
            title="quality: {{data?.safetyAndQuality?.qualityNotification}}&#10;safetyBoard: {{data?.safetyAndQuality?.safetyBoardNotification}}&#10;support: {{data?.safetyAndQuality?.supportNotification}}"
          >
            ...
          </span>
        </td>
      </tr>
    </tbody>
  </table>

  <br/>

  <div style="display: flex; justify-content: space-between">
    <owc-button color="primary" (click)="onDownload()" [disabled]="selectedData.length <= 0">
      Download
    </owc-button>
    <owc-modal-dialog size="large" [(ngModel)]="downloadVisible">
      <dl-file-format-dialog (formatSelected)="onFormatSelected($event)"></dl-file-format-dialog>
    </owc-modal-dialog>

    <div style="display: flex;">
      <owc-button color="primary" (click)="onImport()" [disabled]="selectedData.length <= 0" style="margin-right: 20px;">
        Import
      </owc-button>
  
      <owc-button class="cancel-button" (click)="onCancel()" tabindex="-1">
        Cancel
      </owc-button>
    </div>
  </div>

</div>